'use client';
import { LucideIcon } from 'lucide-react';
import { Toaster } from 'react-hot-toast';
import { ContactUsForm } from './components';
import { organizerBg } from './images';

interface TProps {
  heading?: any;
  subHeading?: string;
  badgeText?: string;
  image?: any;
  form?: {
    title?: string;
    textAreaPlaceholder?: string;
  }
  features?: Array<{
    text: string;
    icon: LucideIcon
  }>
}

const HeroSection = ({
  heading = "Launch Your Event Effortlessly With Greet",
  subHeading = "Created by organizers who faced the chaos and fixed the gaps. Greet is the all-in-one solution we wished we had.",
  badgeText = "Now onboarding organizers",
  image = organizerBg,
  form = {
    title: "What brought you here?",
    textAreaPlaceholder: "Share the details so we can help you out...",
  },
  features
}: TProps) => {

  return (
    <div
      className="flex items-center justify-center relative min-h-screen w-full font-sans text-gray-900 bg-cover"
      style={{ backgroundImage: `url(${image?.src || ''})` }}
      id='hero'
    >
      <div className="relative z-10 max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:gap-16">
          <div className="flex-1 text-center lg:text-left lg:pt-8">
            <div className="inline-flex items-center rounded-full border border-green-500/30 bg-green-500/10 px-3 py-1 text-xs font-medium text-green-400 mb-6 backdrop-blur-sm">
              <span className="flex h-2 w-2 rounded-full bg-green-400 mr-2 animate-pulse"></span>
              {badgeText}
            </div>

            <h1 className="mb-6 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl lg:leading-[1.1]">
              {heading}
            </h1>

            <p className="mb-10 text-base text-gray-300 sm:text-lg lg:max-w-2xl lg:leading-relaxed">
              {subHeading}
            </p>

            <ContactUsForm className='lg:hidden mb-12' />

            <div className="grid gap-x-6 gap-y-4 sm:grid-cols-2 text-left">
              {features?.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="flex items-center gap-3 rounded-lg bg-white/5 p-3 backdrop-blur-sm transition-colors hover:bg-white/10 border border-white/5 cursor-pointer">
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-500/20 text-green-400">
                      <Icon size={16} />
                    </div>
                    <span className="text-xs font-medium text-gray-200">{feature.text}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <ContactUsForm
            formTitle={form?.title}
            textAreaPlaceholder={form?.textAreaPlaceholder}
            className='hidden lg:block'
          />
        </div>
      </div>
      <Toaster position="top-center" />
    </div>
  );
};

export default HeroSection;